import { createSlice } from "@reduxjs/toolkit";


export const guardianDetailsSlice = createSlice({
  name: "guardianDetails",
  initialState: {
    country: "NP",
    countryDesc: "NEPAL",
    guardianDocumentList: [],
    errors: {},
  },
  reducers: {
    setFirstName: (state, action) => {
      state.firstName = action.payload;
      state.errors.firstNameError = {};
      state.pop = "U";
    },
    setMiddleName: (state, action) => {
      state.middleName = action.payload;
      state.errors.middleNameError = {};
      state.pop = "U";
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
      state.errors.lastNameError = {};
      state.pop = "U";
    },
    setFirstNameError: (state, action) => {
      // Ensure firstNameError exists before trying to set its properties
      if (!state.errors.firstNameError) {
        state.errors.firstNameError = {};
      }
      state.errors.firstNameError.message = action.payload.message;
      state.errors.firstNameError.section = action.payload.section;
    },

    setLastNameError: (state, action) => {
      // Ensure setLastNameError exists before trying to set its properties
      if (!state.errors.lastNameError) {
        state.errors.lastNameError = {};
      }
      state.errors.lastNameError.message = action.payload.message;
      state.errors.lastNameError.section = action.payload.section;
    },

    setMiddleNameError: (state, action) => {
      if (!state.errors.middleNameError) {
        state.errors.middleNameError = {};
      }
      state.errors.middleNameError.message = action.payload.message;
      state.errors.middleNameError.section = action.payload.section;
    },

    setFirstNameNep: (state, action) => {
      state.pop = "U";
      state.firstNameNep = action.payload;
      state.errors.firstNameNepError = {};
      //  delete state.errors.firstNameNepError;
    },
    setMiddleNameNep: (state, action) => {
      state.pop = "U";
      state.middleNameNep = action.payload;
      state.errors.middleNameNepError = {};
    },
    setLastNameNep: (state, action) => {
      state.pop = "U";
      state.lastNameNep = action.payload;
      state.errors.lastNameNepError = {};
    },
    setRelationship: (state, action) => {
      state.relationship = action.payload;
      state.errors.relationshipError = {};
      state.op = "U";
    },
    setCountry: (state, action) => {
      state.country = action.payload;
      state.errors.countryError = {};
      state.paop = "U";
    },
    setState: (state, action) => {
      state.state = action.payload;
      state.errors.stateError = {};
      state.paop = "U";
    },
    setDistrict: (state, action) => {
      state.district = action.payload;
      state.errors.districtError = {};
      state.paop = "U";
    },
    setMunicipality: (state, action) => {
      state.municipality = action.payload;
      state.errors.municipalityError = {};
      state.paop = "U";
    },
    setWard: (state, action) => {
      state.ward = action.payload;
      state.errors.wardError = {};
      state.paop = "U";
    },
    setTole: (state, action) => {
      state.tole = action.payload;
      state.errors.toleError = {};
      state.paop = "U";
    },
    setBlockNo: (state, action) => {
      state.blockNo = action.payload;
      state.errors.blockNoError = {};
      state.paop = "U";
    },
    setTelephoneNo: (state, action) => {
      state.telephoneNo = action.payload;
      state.errors.telephoneNoError = {};
      state.paop = "U";
    },
    setEmailId: (state, action) => {
      state.emailId = action.payload;
      state.errors.emailIdError = {};
      state.paop = "U";
    },
    setMobileNo: (state, action) => {
      state.mobileNo = action.payload;
      state.errors.mobileNoError = {};
      state.paop = "U";
    },
    setFax: (state, action) => {
      state.fax = action.payload;
      state.errors.faxError = {};
      state.paop = "U";
    },
    setCountryDesc: (state, action) => {
      state.countryDesc = action.payload;
    },
    setStateDesc: (state, action) => {
      state.stateDesc = action.payload;
    },
    setDistrictDesc: (state, action) => {
      state.districtDesc = action.payload;
    },
    setMunicipalityDesc: (state, action) => {
      state.municipalityDesc = action.payload;
    },
    setRelationshipDesc: (state, action) => {
      state.relationshipDesc = action.payload;
    },
    setPan: (state, action) => {
      state.pan = action.payload;
      state.errors.panError = {};
      state.pop = "U";
    },
    setGuardianData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => (state[key] = action.payload[key])
      );
    },
    clearGuardianData: (state, action) => {
      state.op = "N";
      state.pop = "N";
      state.paop = "N";
    },
    setRelationshipOthers: (state, action) => {
      state.relationshipOthers = action.payload;
      state.errors.relationshipOthersError = {};
      state.op = "U";
    },
    setGFirstNameError: (state, action) => {
      state.errors.firstNameError = {};
      state.errors.firstNameError.message = action.payload.message;
      state.errors.firstNameError.section = action.payload.section;
    },

    setGLastNameError: (state, action) => {
      state.errors.lastNameError = {};
      state.errors.lastNameError.message = action.payload.message;
      state.errors.lastNameError.section = action.payload.section;
    },
    setGFirstNameNepError: (state, action) => {
      state.errors.firstNameNepError = {};
      state.errors.firstNameNepError.message = action.payload.message;
      state.errors.firstNameNepError.section = action.payload.section;
    },

    setGLastNameNepError: (state, action) => {
      state.errors.lastNameNepError = {};
      state.errors.lastNameNepError.message = action.payload.message;
      state.errors.lastNameNepError.section = action.payload.section;
    },
    setGRelationshipError: (state, action) => {
      if (!state.errors.relationshipError) {
        state.errors.relationshipError = {};
      }
      state.errors.relationshipError.message = action.payload.message;
      state.errors.relationshipError.section = action.payload.section;
    },
    // setRelationshipOthersError: (state, action) => {
    //   if (!state.errors.relationshipOthersError) {
    //     state.errors.relationshipOthersError = {};
    //   }
    //   state.errors.relationshipOthersError.message = action.payload.message;
    //   state.errors.relationshipOthersError.section = action.payload.section;
    // },
    setGCountryError: (state, action) => {
      state.errors.countryError = {};
      state.errors.countryError.message = action.payload.message;
      state.errors.countryError.section = action.payload.section;
    },
    setGStateError: (state, action) => {
      state.errors.stateError = {};
      state.errors.stateError.message = action.payload.message;
      state.errors.stateError.section = action.payload.section;
    },
    setGDistrictError: (state, action) => {
      state.errors.districtError = {};
      state.errors.districtError.message = action.payload.message;
      state.errors.districtError.section = action.payload.section;
    },
    setGMunicipalityError: (state, action) => {
      state.errors.municipalityError = {};
      state.errors.municipalityError.message = action.payload.message;
      state.errors.municipalityError.section = action.payload.section;
    },
    setGWardError: (state, action) => {
      state.errors.wardError = {};
      state.errors.wardError.message = action.payload.message;
      state.errors.wardError.section = action.payload.section;
    },
    setGToleError: (state, action) => {
      state.errors.toleError = {};
      state.errors.toleError.message = action.payload.message;
      state.errors.toleError.section = action.payload.section;
    },

    setGEmailIdError: (state, action) => {
      state.errors.emailIdError = {};
      state.errors.emailIdError.message = action.payload.message;
      state.errors.emailIdError.section = action.payload.section;
    },
    setGMobileNoError: (state, action) => {
      state.errors.mobileNoError = {};
      state.errors.mobileNoError.message = action.payload.message;
      state.errors.mobileNoError.section = action.payload.section;
    },
    setGFaxError: (state, action) => {
      state.errors.faxError = {};
      state.errors.faxError.message = action.payload.message;
      state.errors.faxError.section = action.payload.section;
    },
    setGTelephoneNoError: (state, action) => {
      state.errors.telephoneNoError = {};
      state.errors.telephoneNoError.message = action.payload.message;
      state.errors.telephoneNoError.section = action.payload.section;
    },
    setGDocIdError: (state, action) => {
      state.errors.docIdError = {};
      state.errors.docIdError.message = action.payload.message;
      state.errors.docIdError.section = action.payload.section;
    },
    setGIssuedDateError: (state, action) => {
      state.errors.issuedDateError = {};
      state.errors.issuedDateError.message = action.payload.message;
      state.errors.issuedDateError.section = action.payload.section;
    },
    setGIssuedDateBsError: (state, action) => {
      state.errors.issuedDateBsError = {};
      state.errors.issuedDateBsError.message = action.payload.message;
      state.errors.issuedDateBsError.section = action.payload.section;
    },
    setGIssuedFromError: (state, action) => {
      state.errors.issuedFromError = {};
      state.errors.issuedFromError.message = action.payload.message;
      state.errors.issuedFromError.section = action.payload.section;
    },
    setGFileIdError: (state, action) => {
      state.errors.fileIdError = {};
      state.errors.fileIdError.message = action.payload.message;
      state.errors.fileIdError.section = action.payload.section;
    },
    setGBackFileIdError: (state, action) => {
      state.errors.backFileIdError = {};
      state.errors.backFileIdError.message = action.payload.message;
      state.errors.backFileIdError.section = action.payload.section;
    },

    setGuardianSignature: (state, action) => {
      state.signature = action.payload;
      state.gsop = "I";
      state.errors.signature = {};
    },
    setGuardianDocumentValue: (state, action) => {
      if (action.payload.key === "docId")
        state.errors.docIdError = {};
      if (action.payload.key === "issuedDate")
        state.errors.issuedDateError = {};
      if (action.payload.key === "issuedDateBs")
        state.errors.issuedDateBsError = {};
      if (action.payload.key === "issuedFrom")
        state.errors.issuedFromError = {};
      if (action.payload.key === "fileId")
        state.errors.fileIdError = {};
      if (action.payload.key === "backFileId")
        state.errors.backFileIdError = {};
      const document = state.guardianDocumentList.find(
        (d) => d.documentTypeId === action.payload.code
      );

      if (document) {
        document[action.payload.key] = action.payload.value;
        document.op = "U";
      }
    },
    setDocumentTypeListForGuardian: (state, action) => {
      state.guardianDocumentList = action.payload
        .filter((d) => d.usedFor === "G" || d.code === "PH")
        .map((d) => ({
          ...(state.guardianDocumentList.find((d1) => {
            return d1.documentTypeId === d.code;
          }) || {}),
          documentTypeId: d.code,
          documentTypeDesc: d.descEng,
          documentTypeDescNp: d.descNep,
          type: d.type,
          isBothSided: d.isBothSided,
          ...d
        }));
    },
    setGuardianDocumentListData: (state, action) => {
      console.log("----------------");
      state.guardianDocumentList = state.guardianDocumentList.map((d) => {
        const document = action.payload.find(
          (d1) => d1.documentTypeId === d.documentTypeId
        );

        return {
          ...d,
          ...(document || {}),
          documentTypeId: d.documentTypeId,
          documentTypeDesc: d.documentTypeDesc,
          documentTypeDescNp: d.documentTypeDescNp,
          type: d.type,
          isBothSided: d.isBothSided,
        };
      });

      action.payload
        .filter(
          (d) =>
            !state.guardianDocumentList.find(
              (d1) => d1.documentTypeId === d.documentTypeId
            )
        )
        .forEach((d) => {
          state.guardianDocumentList.push(d);
        });
    },
    clearGuardianDetailsError: (state) => {
      state.errors = {};
    },
    appendGuardianAddressData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => {
          state[key] = action.payload[key];
          state.errors && (state.errors[key + 'Error'] = {});
          switch (key) {
            case 'country':
              state.state = null;
            case 'state':
              state.district = null;
            case 'district':
              state.municipality = null;
            case 'municipality':
              state.ward = null;
          }
        }
      );
      state.paop = "U";
    },
  },
});

export const {
  appendGuardianAddressData,
  setGuardianDocumentValue,
  setDocumentTypeListForGuardian,
  setGuardianDocumentListData,
  clearGuardianData,
  setGuardianData,
  setFirstName,
  setMiddleName,
  setLastName,
  setFirstNameError,
  setMiddleNameError,
  setLastNameError,
  setFirstNameNep,
  setMiddleNameNep,
  setLastNameNep,
  setRelationship,
  setCountry,
  setState,
  setDistrict,
  setMunicipality,
  setWard,
  setTole,
  setBlockNo,
  setTelephoneNo,
  setEmailId,
  setMobileNo,
  setFax,
  setRelationshipDesc,
  setCountryDesc,
  setStateDesc,
  setDistrictDesc,
  setMunicipalityDesc,
  setPan,
  setGFirstNameError,
  setGLastNameError,
  setGRelationshipError,
  setGRelationshipOthersError,
  setGFirstNameNepError,
  setGLastNameNepError,
  setGCountryError,
  setGStateError,
  setGDistrictError,
  setGMunicipalityError,
  setGWardError,
  setGToleError,
  setGMobileNoError,
  setGEmailIdError,
  setRelationshipOthers,
  setGFaxError,
  setGTelephoneNoError,
  clearGuardianDetailsError,
  setGDocIdError,
  setGIssuedDateError,
  setGIssuedDateBsError,
  setGIssuedFromError,
  setGFileIdError,
  setGBackFileIdError,
  setGuardianSignature
} = guardianDetailsSlice.actions;

export default guardianDetailsSlice.reducer;
